export const GET_AUDIT_RECORDS_REQUEST = 'AUDIT/GET_AUDIT_RECORDS_REQUEST';
export const GET_AUDIT_RECORDS_SUCCESS = 'AUDIT/GET_AUDIT_RECORDS_SUCCESS';
export const GET_AUDIT_RECORDS_ERROR = 'AUDIT/GET_AUDIT_RECORDS_ERROR';
export const GET_AUDIT_ITEMS_REQUEST = 'AUDIT/GET_AUDIT_ITEMS_REQUEST';
export const GET_AUDIT_ITEMS_SUCCESS = 'AUDIT/GET_AUDIT_ITEMS_SUCCESS';
export const GET_AUDIT_ITEMS_ERROR = 'AUDIT/GET_AUDIT_ITEMS_ERROR';
export const GET_ASSET_AUDITS_REQUEST = 'AUDIT/GET_ASSET_AUDITS_REQUEST';
export const GET_ASSET_AUDITS_SUCCESS = 'AUDIT/GET_ASSET_AUDITS_SUCCESS';
export const GET_ASSET_AUDITS_ERROR = 'AUDIT/GET_ASSET_AUDITS_ERROR';
export const CREATE_AUDIT_REQUEST = 'AUDIT/CREATE_AUDIT_REQUEST';
export const CREATE_AUDIT_SUCCESS = 'AUDIT/CREATE_AUDIT_SUCCESS';
export const CREATE_AUDIT_ERROR = 'AUDIT/CREATE_AUDIT_ERROR';
export const DELETE_AUDIT_REQUEST = 'AUDIT/DELETE_AUDIT_REQUEST';
export const DELETE_AUDIT_SUCCESS = 'AUDIT/DELETE_AUDIT_SUCCESS';
export const DELETE_AUDIT_ERROR = 'AUDIT/DELETE_AUDIT_ERROR';
export const SCAN_AUDIT_ITEM_REQUEST = 'AUDIT/SCAN_AUDIT_ITEM_REQUEST';
export const SCAN_AUDIT_ITEM_SUCCESS = 'AUDIT/SCAN_AUDIT_ITEM_SUCCESS';
export const SCAN_AUDIT_ITEM_ERROR = 'AUDIT/SCAN_AUDIT_ITEM_ERROR';
export const COMPLETE_AUDIT_REQUEST = 'AUDIT/COMPLETE_AUDIT_REQUEST';
export const COMPLETE_AUDIT_SUCCESS = 'AUDIT/COMPLETE_AUDIT_SUCCESS';
export const COMPLETE_AUDIT_ERROR = 'AUDIT/COMPLETE_AUDIT_ERROR';
export const RECONCILE_AUDIT_REQUEST = 'AUDIT/RECONCILE_AUDIT_REQUEST';
export const RECONCILE_AUDIT_SUCCESS = 'AUDIT/RECONCILE_AUDIT_SUCCESS';
export const RECONCILE_AUDIT_ERROR = 'AUDIT/RECONCILE_AUDIT_ERROR';
